import React, { useState, useEffect } from "react";
import "../../../style/landing.css";
import { faqs, billingFaqs, supportFaqs } from "./FAQData";
import img1 from "../../../image/privacy-pop-right-img.webp";
import img2 from "../../../image/privacy-pop-img-left.webp";

import Navbar from "../navbar/Navbar";

const Question = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const [activeIndex, setActiveIndex] = useState({
    gettingStarted: null,
    billing: null,
    support: null,
  });

  const toggleFAQ = (section, index) => {
    setActiveIndex((prevState) => ({
      ...prevState,
      [section]: prevState[section] === index ? null : index,
    }));
  };

  return (
    <>
      <div className="lp-hero-container hero-section">
        <div className="lp-container">
          <Navbar />
          <h1 className="lp-heading">
            Frequently Asked <span style={{ color: "#00BFA6" }}>Questions</span>
          </h1>
          <div className="lp-wailist-section">
            <img src={img2} alt="Newslettrai" className="side-img" />
            <p className="lp-heading-desc">
              Your privacy matters. We safeguard your data while helping you{" "}
              <br />
              create impactful, personalized newsletters.
            </p>
            <img
              src={img1}
              alt="Newslettrai"
              style={{ marginTop: "-80px" }}
              className="side-img"
            />
          </div>
        </div>
      </div>

      {/* Getting Started FAQs */}
      <div className="lp-container">
        <div className="lp-faq-container">
          <h2 style={{ textAlign: "center" }}>Getting Started</h2>
          {faqs.map((faq, index) => (
            <div key={index} className="lp-faq-item">
              <div
                className="lp-faq-question"
                onClick={() => toggleFAQ("gettingStarted", index)}
              >
                {faq.question}
                <span className="lp-faq-toggle">
                  {activeIndex.gettingStarted === index ? "-" : "+"}
                </span>
              </div>
              <div
                className={`lp-faq-answer ${
                  activeIndex.gettingStarted === index ? "open" : ""
                }`}
              >
                <div className="lp-faq-answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Billing & Subscription FAQs */}
        <div className="lp-faq-container">
          <h2 style={{ textAlign: "center" }}>Billing & Subscription</h2>
          {billingFaqs.map((faq, index) => (
            <div key={index} className="lp-faq-item">
              <div
                className="lp-faq-question"
                onClick={() => toggleFAQ("billing", index)}
              >
                {faq.question}
                <span className="lp-faq-toggle">
                  {activeIndex.billing === index ? "-" : "+"}
                </span>
              </div>
              <div
                className={`lp-faq-answer ${
                  activeIndex.billing === index ? "open" : ""
                }`}
              >
                <div className="lp-faq-answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Support & Troubleshooting */}
        <div className="lp-faq-container">
          <h2 style={{ textAlign: "center" }}>Support & Troubleshooting</h2>
          {supportFaqs.map((faq, index) => (
            <div key={index} className="lp-faq-item">
              <div
                className="lp-faq-question"
                onClick={() => toggleFAQ("support", index)}
              >
                {faq.question}
                <span className="lp-faq-toggle">
                  {activeIndex.support === index ? "-" : "+"}
                </span>
              </div>
              <div
                className={`lp-faq-answer ${
                  activeIndex.support === index ? "open" : ""
                }`}
              >
                <div className="lp-faq-answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Question;

//1.5,2.2,2.3,3.4
